import createTrafficSource from './actions/createTrafficSource';
import fetchTrafficSourcesById from './actions/fetchTrafficSourcesById';
import getTrafficSource from './actions/getTrafficSource';
import trafficSourcesList from './actions/trafficSourcesList';
import updateTrafficSource from './actions/updateTrafficSource';
import getTrafficSourceById from './getters/getTrafficSourceById';
import getTrafficSources from './getters/getTrafficSources';
import uploadTrafficSources from './mutations/uploadTrafficSources';

const actions = {
    trafficSourcesList,
    getTrafficSource,
    createTrafficSource,
    updateTrafficSource,
    fetchTrafficSourcesById
};

const mutations = {
    uploadTrafficSources
};

const getters = {
    getTrafficSources,
    getTrafficSourceById
};

export default { actions, mutations, getters };
